<template>
  <div>
    <div
      class="thanks-page-title text-center font-weight-bold"
      :style="$mq === 'sp' ? 'font-size:20px' : 'font-size:24px'"
    >
      {{ title }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ThanksPageTitle',
  data() {
    return {};
  },
  props: {
    title: {
      type: String,
      default: '',
      require: true,
    },
  },
};
</script>

<style scoped lang="scss">
.thanks-page-title {
  padding-bottom: 20px;
  padding-top: 20px;
  background-color: #e4ecf1;
}
</style>
